export default __webpack_public_path__ + "static/media/pexels-thirdman-5327921.18a07a42.jpg";